<template>
  <div class="about-page">
    <section class="header-section">
      <div class="section-container">
        <h1 class="page-title">{{ $t('pages.about.title') }}</h1>
        <p class="page-subtitle">
          {{ $t('pages.about.subtitle') }}
        </p>
      </div>
    </section>

    <section class="content-section">
      <div class="section-container">
        <div class="content-card">
          <h2>{{ $t('pages.about.mission.title') }}</h2>
          <p>{{ $t('pages.about.mission.desc') }}</p>

          <h2>{{ $t('pages.about.tech.title') }}</h2>
          <ul>
            <li>{{ $t('pages.about.tech.items.engine') }}</li>
            <li>{{ $t('pages.about.tech.items.layout') }}</li>
            <li>{{ $t('pages.about.tech.items.formats') }}</li>
            <li>{{ $t('pages.about.tech.items.security') }}</li>
          </ul>

          <h2>{{ $t('pages.about.contact.title') }}</h2>
          <p>{{ $t('pages.about.contact.desc') }}</p>
          <p>{{ $t('pages.about.contact.email') }}: support@ganfanstech.cn</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
useWebsiteSeo({
  title: () => t('seo.pages.about.title'),
  description: () => t('seo.pages.about.desc')
})
</script>

<style scoped lang="scss">
@use 'sass:color';

.about-page {
  min-height: 100vh;
  background: $gray-50;
}

.header-section {
  background: linear-gradient(135deg, $primary-color 0%, $accent-color 100%);
  color: $white;
  padding: $spacing-xxl 0;
  text-align: center;

  .page-title {
    font-size: 3rem;
    font-weight: 700;
    margin: 0 0 $spacing-md 0;
  }

  .page-subtitle {
    font-size: 1.2rem;
    margin: 0;
    opacity: 0.9;
  }
}

.content-section {
  padding: $spacing-xxl 0;

  .section-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 $spacing-lg;
  }

  .content-card {
    background: $white;
    padding: $spacing-xxl;
    border-radius: $border-radius-lg;
    box-shadow: $shadow-lg;

    h2 {
      color: $primary-color;
      margin: $spacing-xl 0 $spacing-md 0;

      &:first-child {
        margin-top: 0;
      }
    }

    p, li {
      line-height: 1.6;
      color: $gray-700;
    }

    ul {
      margin: $spacing-md 0;
      padding-left: $spacing-lg;
    }
  }
}

@media (max-width: 768px) {
  .header-section {
    padding: $spacing-xl 0;

    .page-title {
      font-size: 2rem;
    }
  }

  .content-section {
    .content-card {
      padding: $spacing-lg;
    }
  }
}
</style>
